import { render } from "./search-sort.vue?vue&type=template&id=625045f8&scoped=true"
import script from "./search-sort.vue?vue&type=script&lang=js"
export * from "./search-sort.vue?vue&type=script&lang=js"

import "./search-sort.vue?vue&type=style&index=0&id=625045f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625045f8"]])

export default __exports__